import { styled } from '@mui/material';
import Slider from '@mui/material/Slider';

export const HistogramOverlayRoot = styled('div')({
  position: 'relative',
  height: 250,
});

export const HistogramSlider = styled(Slider)({
  '&.MuiSlider-root': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: 0,
    padding: 0,
    zIndex: 1,
  },
  '& .MuiSlider-rail': {
    backgroundColor: 'transparent',
  },
  '& .MuiSlider-thumb': {
    transition: 'none',
  },
});

export const HistogramContent = styled('div')({
  position: 'relative',
  height: '100%',
});
